import React from 'react';
import { DEFAULT_TERMINAL_WIDTH } from '../../constants';
import { BaseTool } from './BaseTool';
import type { PendingInput, ToolComponentProps } from './types';

export const PendingTool: React.FC<ToolComponentProps<PendingInput>> = ({
  input,
  state,
  expanded,
  columns = DEFAULT_TERMINAL_WIDTH,
}) => (
  <BaseTool
    label={`Building tool \`${input.name}\``}
    state={state}
    expanded={expanded}
    columns={columns}
  />
);
